var render = function () {
  var _vm$editTierSelectedD;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("System ID")]), _c('th', [_vm._v("Name")]), _c('th', [_vm._v("Dates")]), _c('th', [_vm._v("Rep & Employee")]), _vm.renewalStatus ? _c('th', [_vm._v("Current Plan(S) & Premium")]) : _vm._e(), _vm.renewalStatus ? _c('th', [_vm._v("Approved Renewal Plan(s)")]) : _vm._e()])]), _c('tbody', [_vm.isInitialLoad ? _c('tr', [_c('td', {
    staticClass: "empty-state-cell",
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "quick-date-btns-inline d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3"
  }, [_c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'all'
    },
    attrs: {
      "title": "All members"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'all');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-list me-1"
  }), _vm._v(" All Members ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'today'
    },
    attrs: {
      "title": "Members enrolled today"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'today');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-day me-1"
  }), _vm._v(" Members Today ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'week'
    },
    attrs: {
      "title": "Members enrolled this week"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'week');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-week me-1"
  }), _vm._v(" Members This Week ")]), _c('button', {
    staticClass: "quick-date-btn-inline",
    class: {
      active: _vm.activeQuickFilter === 'month'
    },
    attrs: {
      "title": "Members enrolled this month"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('quick-filter', 'month');
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calendar-alt me-1"
  }), _vm._v(" Members This Month ")])]), _vm._m(0)])]) : !_vm.memberLength ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._l(_vm.localMemberLists.records, function (item) {
    var _item$plan_history, _item$renewal_plan_de;

    return _c('tr', {
      key: item.policy_id,
      class: _vm.calssByStatus(item.status),
      attrs: {
        "id": item.status
      }
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(item.policy_id))]), _c('br'), _c('span', {
      class: 'id-status-' + _vm.renewalDisplayStatus(item).toLowerCase(),
      style: item.l713_status || item.ihaStatus ? {
        color: ''
      } : {}
    }, [String(item.l713_status || item.ihaStatus || '').toLowerCase() == 'active' ? _c('valid-icon', {
      staticClass: "valid-icon",
      attrs: {
        "is-valid": true
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(item.l713_status || item.ihaStatus || item.status) + " "), _vm.showHealthQuestionnaires && _vm.hasHealthQuestionnaires(item) ? [_vm._v(_vm._s(item.ihaSubCategory))] : _vm._e()], 2), _c('br')]), _c('td', [_c('strong', [_vm._v(_vm._s(item.first_name) + " " + _vm._s(item.last_name))]), _c('br'), item.employer_type === 'employer' ? [_c('strong', {
      staticClass: "text-red"
    }, [_vm._v("EMPLOYEE")]), _c('br')] : _vm._e(), item.phone ? _c('span', [_vm._v(" " + _vm._s(_vm._f("us_phone")(item.phone)) + " "), item.info_validated ? _c('valid-icon', {
      staticClass: "valid-icon",
      attrs: {
        "is-valid": item.is_phone_valid
      }
    }) : _vm._e()], 1) : _vm._e(), _c('br'), item.user_email ? _c('span', [_vm._v(" " + _vm._s(item.user_email) + " "), item.info_validated ? _c('valid-icon', {
      staticClass: "valid-icon",
      attrs: {
        "is-valid": item.is_email_valid
      }
    }) : _vm._e()], 1) : _vm._e()], 2), _c('td', [_c('strong', [_vm._v("Effective Date:")]), _c('br'), _vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.effective_date)), _c('br'), item !== null && item !== void 0 && item.renewal_date ? [_c('strong', [_vm._v("Renewal Date:")]), _c('br'), _vm._v(_vm._s(_vm._f("date_format")(item.renewal_date, "YYYY-MM-DD", "MM/DD/YYYY", item.renewal_date))), _c('br')] : _vm._e(), item.plan_history && ((_item$plan_history = item.plan_history) === null || _item$plan_history === void 0 ? void 0 : _item$plan_history.length) > 0 ? [item.status === 'TERMED' && item.plan_history[0].plan_status === 'TERMED' ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('strong', [_vm._v("Termed Date:")]), _c('br'), _vm._v(_vm._s(item.plan_history[0].plan_termed_date)), _c('br')]) : _vm._e(), item.status === 'WITHDRAWN' && item.plan_history[0].plan_status === 'WITHDRAWN' ? _c('div', {
      staticStyle: {
        "color": "red"
      }
    }, [_c('strong', [_vm._v("Withdrawn Date:")]), _c('br'), _vm._v(_vm._s(item.plan_history[0].plan_termed_date)), _c('br')]) : _vm._e()] : _vm._e()], 2), _c('td', [_c('strong', [_c('router-link', {
      staticClass: "route-link",
      attrs: {
        "to": {
          name: 'MemberListByRep',
          params: {
            repId: _vm.encodedId(item.agent_id)
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.rep_first_name) + " " + _vm._s(item.rep_last_name) + " ")])], 1), _c('br'), _vm._v(" " + _vm._s(item.agent_code) + " "), item.business_name && item.business_name !== 'N/A' ? _c('br') : _vm._e(), item.business_name && item.business_name !== 'N/A' ? [_vm._v(" Business Name: " + _vm._s(item.business_name) + " ")] : _vm._e(), _c('br'), item.employer_name && !_vm.isEnrollPrime ? [_vm._v(" Employer Name: "), _c('router-link', {
      staticClass: "route-link",
      attrs: {
        "to": {
          name: 'MemberListByGroup',
          params: {
            groupId: _vm.encodedId(item.employer_id)
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(item.employer_name) + " ")])] : _vm._e()], 2), _vm.renewalStatus ? _c('td', [_vm.renewalCurrentPlans(item).length ? _c('table', {
      staticClass: "table premiums-table"
    }, _vm._l(_vm.renewalCurrentPlans(item), function (planItem, index) {
      return _c('tr', {
        key: planItem.plan_id || index
      }, [_c('td', {
        class: _vm.isTermedPlan(planItem) ? 'text-red' : ''
      }, [_vm._v(" " + _vm._s(planItem.plan_name_system) + " "), _vm.isTermedPlan(planItem) && (planItem.plan_termed_date || planItem.plan_term_date) ? [_c('br'), _vm._v(_vm._s("(".concat(planItem.plan_termed_date || planItem.plan_term_date, ")")) + " ")] : _vm._e(), _c('div', {
        staticClass: "d-flex align-items-center justify-content-start p-0"
      }, [_c('strong', {
        staticClass: "me-1"
      }, [_vm._v("Tier:")]), _c('span', [_vm._v(_vm._s(planItem.plan_tier))])])], 2), _c('td', [_vm._v(_vm._s("$" + planItem.plan_price))])]);
    }), 0) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]) : _vm._e(), _vm.renewalStatus ? _c('td', [_vm.renewalDisplayStatus(item) === 'PENDING-RENEWAL-UNDERWRITING' ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")]) : _vm.renewalDisplayStatus(item) === 'ACTIVE' ? _c('div', {
      staticClass: "renewal-approved-tick"
    }, [_c('i', {
      staticClass: "fas fa-check-circle"
    })]) : [(_item$renewal_plan_de = item.renewal_plan_details) !== null && _item$renewal_plan_de !== void 0 && _item$renewal_plan_de.length ? _c('table', {
      staticClass: "table premiums-table"
    }, _vm._l(item.renewal_plan_details, function (plan) {
      return _c('tr', {
        key: plan.plan_id
      }, [_c('td', [_vm._v(" " + _vm._s(plan.plan_name) + " "), _c('div', {
        staticClass: "d-flex align-items-center justify-content-start p-0"
      }, [_c('strong', {
        staticClass: "me-1"
      }, [_vm._v("Tier:")]), _c('span', [_vm._v(_vm._s(plan.plan_tier))])])]), _c('td', [_vm.hasRenewalPrice(plan) ? [plan.renewal_price !== plan.current_price ? _c('strong', [_vm._v(_vm._s("$" + plan.renewal_price))]) : _c('span', [_vm._v(_vm._s("$" + plan.renewal_price))]), plan.renewal_price !== plan.current_price ? void 0 : _vm._e()] : _c('span', {
        staticClass: "text-muted"
      }, [_vm._v("N/A")])], 2)]);
    }), 0) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("N/A")])]], 2) : _vm._e()]);
  })], 2)]), _c('WaiveEfeeLogs', {
    attrs: {
      "show": _vm.showWaiveEfeeLogs,
      "row": _vm.row,
      "type": 'member'
    },
    on: {
      "onCloseModal": _vm.closeWaiveEfeeLogs
    }
  }), _c('member-doc-modal', {
    attrs: {
      "member": _vm.selectedMember
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.selectedMember = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.selectedMember = null;
      }
    }
  }), _c('member-upload-media-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-email-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-resend-email-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-signature-email-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-payment-history-modal', {
    attrs: {
      "member": _vm.selectedMember,
      "showPaymentModal": _vm.showPaymentModal
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.selectedMember = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.selectedMember = null;
      },
      "update:showPaymentModal": function updateShowPaymentModal($event) {
        _vm.showPaymentModal = $event;
      },
      "update:show-payment-modal": function updateShowPaymentModal($event) {
        _vm.showPaymentModal = $event;
      }
    }
  }), _c('member-change-platform-modal', {
    attrs: {
      "member": _vm.row,
      "showChangePlatformModal": _vm.showChangePlatformModal
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": _vm.closeChangePlatformModal,
      "update:showChangePlatformModal": function updateShowChangePlatformModal($event) {
        _vm.showChangePlatformModal = $event;
      },
      "update:show-change-platform-modal": function updateShowChangePlatformModal($event) {
        _vm.showChangePlatformModal = $event;
      }
    }
  }), _c('member-send-login-email-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-change-major-medical-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('approve-plan-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('effective-policy-date-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('default-otp-modal', {
    attrs: {
      "row": _vm.row,
      "rowType": "M"
    },
    on: {
      "update:row": function updateRow($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('member-plan-termination-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('send-referral-link-to-user', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      }
    }
  }), _c('MemberPlanHistoryModal', {
    attrs: {
      "member": _vm.row,
      "showPlanHistoryModal": _vm.showPlanHistoryModal
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      },
      "update:showPlanHistoryModal": function updateShowPlanHistoryModal($event) {
        _vm.showPlanHistoryModal = $event;
      },
      "update:show-plan-history-modal": function updateShowPlanHistoryModal($event) {
        _vm.showPlanHistoryModal = $event;
      }
    }
  }), _c('PlanRenewalSwitchModal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      }
    }
  }), _c('member-notes-modal', {
    attrs: {
      "member": _vm.row,
      "showNotesModal": _vm.showNotesModal
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": _vm.closeNotesModal,
      "update:showNotesModal": function updateShowNotesModal($event) {
        _vm.showNotesModal = $event;
      },
      "update:show-notes-modal": function updateShowNotesModal($event) {
        _vm.showNotesModal = $event;
      }
    }
  }), _c('member-card-payments-modal', {
    attrs: {
      "member": _vm.row,
      "showCardPaymentsModal": _vm.showCardPaymentsModal
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": _vm.closeCardPaymentsModal,
      "update:showCardPaymentsModal": function updateShowCardPaymentsModal($event) {
        _vm.showCardPaymentsModal = $event;
      },
      "update:show-card-payments-modal": function updateShowCardPaymentsModal($event) {
        _vm.showCardPaymentsModal = $event;
      }
    }
  }), _c('EnrollCardRequestModal', {
    attrs: {
      "row": _vm.selectedMember
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.selectedMember = null;
      }
    }
  }), _c('term-policy-modal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      }
    }
  }), _c('EditRecurringDateModal', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "update:member": function updateMember($event) {
        _vm.row = $event;
      },
      "onCloseModal": function onCloseModal($event) {
        _vm.row = null;
      },
      "onRecurringCloseModal": _vm.handleRecurringCloseModal
    }
  }), _c('EditMemberTierModal', {
    attrs: {
      "isOpen": _vm.isEditTierDialogOpen,
      "existingSpouse": true,
      "members": _vm.editTierSelectedData,
      "policyId": Number((_vm$editTierSelectedD = _vm.editTierSelectedData) === null || _vm$editTierSelectedD === void 0 ? void 0 : _vm$editTierSelectedD.policy_id)
    },
    on: {
      "saveTier": _vm.handleTierUpdate,
      "onCloseModal": function onCloseModal($event) {
        _vm.isEditTierDialogOpen = false;
      }
    }
  }), _c('ScreenshotViewerModal', {
    attrs: {
      "show": _vm.showScreenshotViewerModal,
      "screenshots-data": _vm.screenshotsData
    },
    on: {
      "onCloseModal": function onCloseModal($event) {
        _vm.showScreenshotViewerModal = false;
      }
    }
  }), _c('WaiveEfeeModal', {
    attrs: {
      "show": _vm.showWaiveFeeModal,
      "row": _vm.row,
      "type": 'member'
    },
    on: {
      "onCloseModal": _vm.closeWaiveEfeeModal,
      "onSuccess": _vm.closeWaiveEfeeModal
    }
  }), _c('LogDisplayModal', {
    attrs: {
      "isOpen": _vm.isLogModalOpen,
      "logData": _vm.switchLogData,
      "userId": _vm.selectedMemberId,
      "logType": 'member'
    },
    on: {
      "update:isOpen": function updateIsOpen($event) {
        _vm.isLogModalOpen = $event;
      }
    }
  }), _c('HealthQuestionnaires', {
    attrs: {
      "member": _vm.row
    },
    on: {
      "close": _vm.closeHealthQuestionnairesModal
    },
    model: {
      value: _vm.showHealthQuestionnairesModal,
      callback: function callback($$v) {
        _vm.showHealthQuestionnairesModal = $$v;
      },
      expression: "showHealthQuestionnairesModal"
    }
  }), _c('AddMemberNotesModal', {
    attrs: {
      "row": _vm.row,
      "isOpen": _vm.showAddNotesModal
    },
    on: {
      "close": function close($event) {
        _vm.showAddNotesModal = false;
      }
    }
  }), _c('ViewMemberNotesModal', {
    attrs: {
      "isOpen": _vm.showViewNotesModal,
      "row": _vm.row
    },
    on: {
      "close": function close($event) {
        _vm.showViewNotesModal = false;
      }
    }
  }), _c('MedicationDetails', {
    attrs: {
      "show": _vm.showMedicationModal,
      "row": _vm.row
    },
    on: {
      "onCloseModal": _vm.closeMedicationModal
    }
  }), _c('RaiseIhaIssueModal', {
    attrs: {
      "isOpen": _vm.showRaiseIhaIssueModal,
      "row": _vm.row
    },
    on: {
      "close": function close($event) {
        _vm.showRaiseIhaIssueModal = false;
      }
    }
  }), _c('MemberFileUploadAccess')], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "empty-state-msg"
  }, [_c('i', {
    staticClass: "fas fa-search me-2"
  }), _vm._v(" Enter search criteria or use a quick search above to display results. ")]);
}]

export { render, staticRenderFns }